<template>

  <nx-bform-group :label="$t('eCert')" v-bind="$attrs">
    <slot>
     <div>
      <div style="padding: 1.5rem 0 !important;">
       
        <div>
          <table class="esh-bd-table upload-table dataTable pad-bottom" style="min-width: 800px;">
            <thead>
              <tr>
                <th style="width:100px">{{$t('cert.issuedTo')}}</th>
                <th style="width:100px">{{$t('cert.serial')}}</th>
                <th>{{$t('cert.issuedBy')}}</th>
                <th style="width:100px">{{$t('cert.expiryDate')}}</th>
                <th style="width:50px">{{$t('cert.action')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cert, key) in certs" :key="key">
                  <td style="width:100px">{{cert.issuedTo}}</td>
                  <td style="width:100px">{{cert.serialNumber}}</td>
                  <td>{{cert.issuedBy}}</td>
                  <td style="width:100px">{{moment(cert.expiryDate).local().format('DD MMM YYYY')}}</td>
                  <td style="width:50px">
                    <i style="cursor:pointer" class="fas fa-trash-restore-alt my-icon"  
                      v-b-tooltip.hover :title="$t('cert.remove-cert-hover')"
                      @click="showRemoveCertModal(cert)" />
                  </td>
              </tr>
              <tr v-if="certs.length==0">
                  <td colspan="99">{{$t('cert.noRecord')}}</td>   
              </tr>
            </tbody>
          </table>

        </div>
        <div style="margin-top:10px">
          <b-button class="esh-bd-button" v-if="certs.length==0" @click="openAddCertModal()" href="javascript:void(0);">{{$t('cert.add')}}</b-button>
        </div>

      </div>
      
        <AddCertModal
            v-model="showAddCertModal"
            :name="name"
            :guid="guid"
            @addComplete="addComplete()"
          />

      <b-modal 
          id="remove-cert"
          modal-class="bd-modal"
          centered
          :title="$t('cert.remove-cert-hover')">
          <p>{{$t('cert.remove-cert-msg')}}</p>
          <template #modal-footer="{cancel}">
            <b-button class="bd-button" @click="removeCert()">{{$t('cert.confirm')}}</b-button>
            <b-button variant="danger" @click="cancel()">{{$t('cert.cancel')}}</b-button>
          </template>
        </b-modal>
    </div>
    </slot>
  </nx-bform-group>

</template>

<script>
import { EshApi} from "@/api";
import moment from 'moment';
import AddCertModal from './AddCertModal.vue';

export default {

  components: {
    AddCertModal
  },
  props: {
    guid: {
      type: String,
    },
    name:{
      type: String,
    },
  },
  data() {
    return {
      certs: [],
      showAddCertModal:false
    };
  },
  watch: {
    guid: {
      handler(guid) {
        if (!guid) {
          return;
        }
        console.log("guid",guid);
        this.getCerts();
      },
      immediate: true
    }
  },
  async created() {
    this.moment = moment;
    this.getCerts();
  },
  methods: {
    async getCerts(){
      if(this.guid)
      {
        const { data: certs } = await EshApi.getCertsByGuid(this.guid);
        this.certs = certs;
        this.$emit("setName",this.certs.length>0);
        this.$emit("setFullName",this.certs);
      }
     
    },
    showRemoveCertModal(cert){
      this.selectedCert = cert;
      this.$bvModal.show('remove-cert');
    },
    async removeCert(cert){
      // if(!confirm("Are you sure to delete this certification?")) return;
      // await EshApi.removeCert(cert.id);
      // await this.getCerts();
       await EshApi.removeCertByGUID(this.selectedCert.id,this.guid);
      this.$bvModal.hide('remove-cert');
      this.getCerts();
    },
    openAddCertModal()
    {
      this.showAddCertModal =true;
    },
    async addComplete()
    {
      this.showAddCertModal =false;
      await this.getCerts();
    }
  
  }
};
</script>

<style lang="scss" scoped>
// .upload-table-wrapper {
//   padding: 0 !important;
// }

.upload-table {
  // ::v-deep {
  //   .dataTables_wrapper table {
  //     //border-radius: 0;

  //     th {
  //       &:first-child {
  //         border-radius: 0 0 0 0;
  //       }

  //       &:last-child {
  //         border-radius: 0 0 0 0;
  //       }
  //     }
  //   }
  // }
}

.upload-file {
  overflow: hidden;

  &__form {
    height: 8rem;
    ::v-deep .custom-file-label {
      border: 0px;
      border-top: 1px solid #e9ecef;
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
      &:after {
        height: 100%;
        border-radius: 0rem;
        padding: 2rem 0rem;
      }
      :disabled {
        cursor: not-allowed;
      }
    }
  }
}

.upload-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0;
}

.left-btn{
  margin-left:10px !important;
}

.upload-file-error
{
  padding-bottom: 10px;
}

.bd-button
{
  border-radius: .25rem !important;
}

table.dataTable.no-footer {
    border-bottom: 0px solid #ddd;
  }

.request-signing-body
{
  height:100px;
}


.my-icon{
  cursor:pointer;
    font-size: 1.5em;

}

.my-icon:hover{
  color:orange;
  
}

</style>

<i18n src="@/locales/registration.locale"></i18n>
